import {useMapContext} from '@/components/MindMap/index.mjs'

export default () => {
    const map = useMapContext()
    const selectedNodes = map.useSelectedNodes()
    const {canCopySpecDescription, copySpecDescription} = map.commands
    const nodes = canCopySpecDescription(selectedNodes)

    return {
        disabled: 0 === nodes.length,
        label: '复制spec-description',
        onClick: () => copySpecDescription(nodes),
    }
}
